import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import logo from "../assets/image.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);


  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

 // const handleScrollToSection = (id) => {
  //  if (location.pathname === "/") {
    //  const section = document.getElementById(id);
      //if (section) {
        //section.scrollIntoView({ behavior: "smooth" });
      //}
    //}
    //setIsMenuOpen(false);
  //};

  return (
    <header className="relative z-50 text-black py-4 px-6 shadow-md flex justify-between items-center">
      {/* Logo */}
      <div className="flex items-center space-x-2">
        <Link to="/">
          <img
            src={logo}
            alt="PoemXtra Logo"
            className="h-12 w-auto object-contain"
          />
        </Link>
      </div>

      {/* Hamburger Icon */}
      <button
        onClick={toggleMenu}
        className="text-blue-800 text-3xl md:hidden focus:outline-none"
        aria-label="Toggle menu"
      >
        <FaBars />
      </button>

      {/* Sliding Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-3/4 max-w-sm bg-white shadow-lg z-50 transform transition-transform duration-300 ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <button
          onClick={toggleMenu}
          className="text-blue-800 text-3xl absolute top-4 right-4 focus:outline-none"
          aria-label="Close menu"
        >
          <FaTimes />
        </button>
        <nav className="flex flex-col items-center justify-center h-full space-y-8 text-lg">
        <Link
    to="/"
    className="hover:text-blue-600 transition-colors"
  >
    Home
  </Link>
  <Link
    to="/about"
    className="hover:text-blue-600 transition-colors"
  >
    About
  </Link>
  <Link
          to="/featured-poems"
          className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
        >
          Poems
  </Link>
  <div className="relative">
    <button
      onClick={toggleDropdown}
      className="hover:text-blue-600 transition-colors flex items-center"
    >
      Stories <FaChevronDown className="ml-1" />
    </button>
    {isDropdownOpen && (
      <div className="absolute left-0 mt-2 w-48 bg-white border rounded-md shadow-lg">
        <Link
          to="/featured-stories"
          className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
        >
          Stories
        </Link>
        <Link
          to="/featured-knowledge"
          className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
        >
          Knowledge Hub
        </Link>
        <Link
          to="/featured-scholarships"
          className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
        >
          Scholarships
        </Link>
        <Link
          to="/featured-essay"
          className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
        >
          Essay
        </Link>
      </div>
    )}
  </div>
  <Link
    to="/contact"
    className="hover:text-blue-600 transition-colors"
  >
    Contact
  </Link>
  <Link
    to="/login"
    className="border-2 border-blue-600 text-blue-600 py-2 px-6 rounded-full hover:bg-blue-600 hover:text-white transition duration-300 ease-in-out"
  >
    Login
  </Link>

        </nav>
      </div>

      {/* Standard Navigation Menu for Larger Screens */}
      <nav className="hidden md:flex space-x-6 items-center">
  <Link
    to="/"
    className="hover:text-blue-600 transition-colors"
  >
    Home
  </Link>
  <Link
    to="/about"
    className="hover:text-blue-600 transition-colors"
  >
    About
  </Link>
  <Link
          to="/featured-poems"
          className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
        >
          Poems
  </Link>
  <div className="relative">
    <button
      onClick={toggleDropdown}
      className="hover:text-blue-600 transition-colors flex items-center"
    >
      Stories <FaChevronDown className="ml-1" />
    </button>
    {isDropdownOpen && (
      <div className="absolute left-0 mt-2 w-48 bg-white border rounded-md shadow-lg">
        <Link
          to="/featured-stories"
          className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
        >
          Stories
        </Link>
        <Link
          to="/featured-knowledge"
          className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
        >
          Knowledge Hub
        </Link>
        <Link
          to="/featured-scholarships"
          className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
        >
          Scholarships
        </Link>
        <Link
          to="/featured-essay"
          className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
        >
          Essay
        </Link>
      </div>
    )}
  </div>
  <Link
    to="/contact"
    className="hover:text-blue-600 transition-colors"
  >
    Contact
  </Link>
  <Link
    to="/login"
    className="border-2 border-blue-600 text-blue-600 py-2 px-6 rounded-full hover:bg-blue-600 hover:text-white transition duration-300 ease-in-out"
  >
    Login
  </Link>
</nav>

    </header>
  );
};

export default Header;
